module.exports = "/_next/static/images/9c39708d1e5336a9cde5b9ac92cc2f95-pay-yourself-xs@1x.jpg.webp";